module.exports = __webpack_public_path__ + "img/affiliate.79057486.svg";